var btn = document.getElementsByClassName('b-video-button__button');
var load = document.getElementsByClassName('b-video-button__previous');
if(btn[0]) {
  btn[0].onclick = function() {
    load[0].classList.add("active");
     player.playVideo();
  }
}


// WEBPACK FOOTER //
// ./src/js/pages/object/preload-video.js